'use strict'

import store from '@/store'
import axios from 'axios'
import {queryEncode, getCookie, delCookie, deleteAllCookie} from '@/assets/utils/CommonUtil'
import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'
import {processParams, isSameUser} from '@/assets/utils'
import Vue from 'vue'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 10 * 60 * 1000, // Timeout
  withCredentials: false // Check cross-site Access-Control
}
export const ContentType = {
  formData: 'application/x-www-form-urlencoded',
  json: 'application/json'
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

function handleParams (params) {
  let _time = new Date().getTime()
  if (params) {
    params._time = _time
  } else {
    params = {
      _time: _time
    }
  }
  return params
}

let api = {
  get (url, params, headers) {
    params = handleParams(params)
    return sendRequest('GET', url, {...params}, headers)
  },
  post (url, params, headers) {
    if (params && params.noCache) {
      delete params.noCache
    } else {
      // params = handleParams(params)
    }
    return sendRequest('POST', url, {...params}, headers)
  },
  postArr (url, params, headers) {
    return sendRequest('POST', url, params, headers)
  },
  put (url, params, headers) {
    // params = handleParams(params)
    return sendRequest('PUT', url, {...params}, headers)
  },
  patch (url, params, headers) {
    // params = handleParams(params)
    // console.log(params)
    return sendRequest('PATCH', url, {...params}, headers)
  },
  patchArr (url, params, headers) {
    // params = handleParams(params)
    // console.log(params)
    return sendRequest('PATCH', url, params, headers)
  },
  putArr (url, params, headers) {
    return sendRequest('PUT', url, params, headers)
  },
  delete (url, params, headers) {
    // params = handleParams(params);
    return sendRequest('Delete', url, {...params}, headers)
  },
  deleteArr (url, params, headers) {
    // params = handleParams(params);
    return sendRequest('DeleteBody', url, params, headers)
  },
  deleteBody (url, params, headers) {
    // params = handleParams(params);
    return sendRequest('DeleteBody', url, params, headers)
  }
}

let requestedUrls = {}

function getTimeoutPromise (url) {
  let timeout = 1000 * 60 * 30 // 10000
  // 上传文件相关请求 超时时间设置长一点 30分钟
  if (url.indexOf('/upload_history/upload_result') > -1 || url.indexOf('/file/upload') > -1) {
    timeout = 1000 * 60 * 30
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // 如果该url还未处理完毕
      if (!requestedUrls[url]) {
        reject(new Error({message: '请求超时', code: -9}))
      } else {
        // console.info('该url处理完毕', url)
      }

      // 删除这个url的引用
      delete requestedUrls[url]
    }, timeout)
  })
}

let debounceRequest = {}

// 共用的请求数据方法
function sendRequest (method, url, params, headers = {'Content-Type': 'application/json'}) {
  let href = window.location.href
  href = href.substring(href.indexOf('#/') + 1)
  if (!(/^\/index(\?|$)/.test(href))) {
    // window 里面的用户 不是 cookie里的用户 多页签 多账号登录时 踢出当前用户
    if (!isSameUser()) {
      store.commit('config/SET_CONFIG_STATE', {sessionAlertShow: true})
      return new Promise(resolve => resolve())
    }
  }

  const setSpaceType = (type) => {
    console.log(typeOf(params))
    if (typeOf(params) === 'String') {
      url = processParams(url, {spaceType: type})
    } else if (typeOf(params) === 'Object' || typeOf(params) === 'Form') {
      if (params.append && typeOf(params.append) === 'Function') {
        params.append('spaceType', type)
      } else {
        params.spaceType = type
      }
    }
  }
  if (/\/data_manage\//.test(url)) {
    // 数据库相关的页面 的接口 区分空间类型
    if (/^\/database\/basis/.test(href)) {
      //  获取电子档案室下的数据
      setSpaceType(2)
    } else if (/^\/database\/material\/upload/.test(href)) {
      // 人材机数据 上传excel 员工数据spaceType: 1; 电子档案室spaceType: 2
      const spaceType = sessionStorage.getItem('databaseSpaceType') || 1
      setSpaceType(spaceType)
    }
  }

  if (getCookie('ZJYTOKEN')) {
    headers['token'] = getCookie('ZJYTOKEN')
  }
  // if (sessionStorage.getItem('geipOrgId')){
  //   headers['geipOrgId'] = sessionStorage.getItem('geipOrgId')// 配合薛寒调试-造价云组件
  // }
  if (getCookie('GEIPTOKEN')){
    headers['geipToken'] = getCookie('GEIPTOKEN') || sessionStorage.getItem('geipToken')// 配合薛寒调试-造价云组件
    headers['Authorization'] = 'bearer ' + getCookie('GEIPTOKEN') || sessionStorage.getItem('geipToken')
  }
  if (getCookie('geipOrgIdValue')){
    headers['geipOrgId'] = getCookie('geipOrgIdValue')
  }
  if (method === 'GET' || method === 'Delete') {
    url = processParams(url, params)
  }
  if (method === 'DeleteBody') {
    method = 'Delete'
  }

  // 根据是否有token 添加header
  //     if(!headers){
  //       headers = {}
  //     }
  //
  //     headers = Object.assign({},headers,)
  //
  let pRequest = new Promise((resolve, reject) => {
    if (debounceRequest[url] && debounceRequest[url].method === 'Delete') {
      if (new Date().getTime() < debounceRequest[url].time + 10) {
        reject(new Error('error logs'))
        return
      }
    }
    debounceRequest[url] = {
      time: new Date().getTime(),
      method
    }
    axios({
      method,
      url,
      data: method === 'GET' ? {} : (headers['Content-Type'] || headers['Content-type']).indexOf('application/x-www-form-urlencoded') > -1 ? queryEncode(params) : params,
      headers
    }).then((ret) => {
      requestedUrls[url] = true
      // 需要再测试
      // console.log("=======",ret)
      try {
        // const path = window.location.href;
        if (+ret.data.code === 400) {
          const userInfoInStore = store.state.user.user || {}
          const userInfoInCookie = getCookie('ZJYUSERINFO')
          if (JSON.stringify(userInfoInStore) === '{}' && userInfoInCookie) {
            store.commit('user/SET_USERINFO', JSON.parse(userInfoInCookie))
          }
        }
        //  && !/\/index\/?(\?|$)/.test(path)
        if (+ret.data.code === 401) {
          console.log('~~~~~~~~~~~~登录状态失效了~~~~~~~~~')
          if (!window.__POWERED_BY_QIANKUN__){
            console.log(store.state.config.sessionAlertShow)
            if (!store.state.config.sessionAlertShow) {
            // 弹出 session 超时 弹窗
              store.commit('user/SET_USERINFO', {})
              delCookie('ZJYUSERINFO')
              store.commit('config/SET_CONFIG_STATE', {
                sessionAlertShow: true
              })
            }
            deleteAllCookie()
            this.$router.push({path: '/index'})
          } else {
            Vue.prototype.$microAppStore.setState({
              invalidToken: true
            })
          }

        } else if (+ret.data.code === 310001) {
          // 没有购买套餐
          if (!store.state.config.noUsablePackageAlertShow) {
            // 弹出 没有购买套餐 弹窗
            store.commit('config/SET_CONFIG_STATE', {
              noUsablePackageAlertShow: true
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
      resolve(ret.data)
    }).catch((err) => {
      reject(new Error(err))
    })
  })
  return Promise.race([getTimeoutPromise(url), pRequest])
}


export default api

// Plugin.install = function(Vue, options) {
//   Vue.axios = _axios;
//   window.axios = _axios;
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get() {
//         return _axios;
//       }
//     },
//     $axios: {
//       get() {
//         return _axios;
//       }
//     },
//   });
// };
//
// Vue.use(Plugin)
//
// export default Plugin;
